export default __webpack_public_path__ + "static/media/icons8-unread-messages-more.f7effcd8.svg";